import { render, staticRenderFns } from "./SFGoodsMangement.vue?vue&type=template&id=5f1379ac&scoped=true&"
import script from "./SFGoodsMangement.vue?vue&type=script&lang=js&"
export * from "./SFGoodsMangement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1379ac",
  null
  
)

export default component.exports